import { Action } from 'redux';

import { ReducerFns } from '../insight/insight.reducer';

import {
    ActionType,
    SuperGroupSelectAction,
    SuperGroupSelectResultAction,
} from './human-insight.action';
import { defaultState, RootState } from './human-insight.state';

const superGroupFns: ReducerFns<RootState, ActionType> = {
    [ActionType.HUMAN_INSIGHT__SUPER_GROUP__SELECT](
        state,
        action: SuperGroupSelectAction,
    ): RootState {
        return {
            ...state,
            superGroup: {
                ...state.superGroup,
                pending: true,
                active: undefined,
            },
        };
    },
    [ActionType.HUMAN_INSIGHT__SUPER_GROUP__SELECT_RESULT](
        state,
        action: SuperGroupSelectResultAction,
    ): RootState {
        return {
            ...state,
            superGroup: {
                ...state.superGroup,
                pending: false,
                quickSwitch: action.quickSwitch,
                filteredItems: action.filteredItems,
                active: action.superGroup,
            },
        };
    },
};

const reducerFns: ReducerFns<any, any> = {
    ...superGroupFns,
};

const humanInsight = (
    state: RootState = defaultState(),
    action: Action<ActionType>,
): RootState => {
    const fn = reducerFns[action.type];
    if (fn) {
        return fn(state, action);
    }
    return state;
};

export default {
    humanInsight,
};
